import { Mutex } from 'async-mutex'
import {
  getSectionsHistoryTop,
  getSectionTop,
  listen,
  popFromPanel,
} from './service'
import { getHistoryCustomBack } from './utils/hooks'
import { HistoryEvent, Listeners } from './listeners'

export function resetPathname() {
  window.history.replaceState(window.history.state, null, '/')
}

const HISTORY_CONSTANT_LENGTH = 10

let isReadyToCloseResolver: null | ((value: unknown) => void) = null
let controlledBack = false

const mutex = new Mutex()

async function makeBrowserHistoryEmpty() {
  const releaser = await mutex.acquire()

  const { depth } = window.history.state || {}
  if (depth) {
    controlledBack = true

    if (depth) {
      for (let i = 0; i < depth; i++) window.history.back()
    }

    await new Promise(resolve => {
      isReadyToCloseResolver = resolve
    })
  }

  releaser()
}

let preventCloseLocked = false
function fillBrowserHistoryForFuturePops(calledByPop: boolean) {
  if (preventCloseLocked) return
  preventCloseLocked = true

  const { depth: lastDepth } = window.history.state || {}

  if (!lastDepth || !calledByPop) {
    for (let i = (lastDepth || 0) + 1; i <= HISTORY_CONSTANT_LENGTH; i++)
      window.history.pushState({ depth: i }, '')
  }

  setTimeout(() => {
    preventCloseLocked = false
  }, 500)
}

listen(e => {
  fillBrowserHistoryForFuturePops(e === HistoryEvent.POP)
})

async function closeApp() {
  await makeBrowserHistoryEmpty()
  window.history.back()
}

window.addEventListener('popstate', async () => {
  if (controlledBack) {
    isReadyToCloseResolver?.(undefined)
    isReadyToCloseResolver = null

    controlledBack = false
    return
  }

  const activeSection = getSectionsHistoryTop()

  const activePanel = activeSection ? getSectionTop(activeSection) : 'root'
  if (activePanel === 'INIT') return

  const customBack = getHistoryCustomBack(activePanel)
  if (customBack) {
    const res = customBack()
    if (res === 'closeApp') await closeApp()

    Listeners.notify(HistoryEvent.POP)
    return
  }

  popFromPanel(activePanel)
})
